<!-- 表口径列表 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表口径')">
              <a-input :placeholder="$t('请输入表口径')" v-model="queryParam.mtCaliber"></a-input>
            </a-form-item>
          </a-col>
          <!--
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="口径单位">
              <j-dict-select-tag v-model="queryParam.mtCaliberUnit" placeholder="请选择口径单位" dictCode="mt_caliber_unit"/>
            </a-form-item>
          </a-col>
          -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'mtCaliber:add'">{{ $t('新增') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" v-has="'mtCaliber:delete'" />{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)" v-has="'mtCaliber:edit'">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a v-has="'mtCaliber:delete'">{{ $t('删除') }}</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <meter-caliber-modal ref="modalForm" @ok="modalFormOk"></meter-caliber-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterCaliberModal from './modules/MeterCaliberModal'
  export default {
    name: 'MeterCaliberList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      MeterCaliberModal
    },
    data () {
      return {
        description: 'meter_caliber管理页面',
        url: {
          list: "/jeecg-charge/meter/meterCaliber/list",
          delete: "/jeecg-charge/meter/meterCaliber/delete",
          deleteBatch: "/jeecg-charge/meter/meterCaliber/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterCaliber/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterCaliber/importExcel",  
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表口径'),
            align:"center",
            dataIndex: 'mtCaliber',
            customRender: (text,row) => {
              //字典值替换通用方法
              return 'DN'+text//+filterDictTextByCache('mt_caliber_unit', row.mtCaliberUnit)+'';
            }
          }/*,{
            title:'口径单位',
            align:"center",
            dataIndex: 'mtCaliberUnit',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('mt_caliber_unit', text);
            }
          }
          ,{
            title:'标准流量',
            align:"center",
            dataIndex: 'standFlow'
          },{
            title:'最大流量',
            align:"center",
            dataIndex: 'maxFlow'
          },{
            title:'日报警上限',
            align:"center",
            dataIndex: 'warnTopDay'
          },{
            title:'日报警下限',
            align:"center",
            dataIndex: 'warnLowDay'
          },{
            title:'强检年限',
            align:"center",
            dataIndex: 'ageLimitMonth'
          }
          */
          ,{
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          /*
          {
            title:'创建人',
            align:"center",
            dataIndex: 'createBy'
          },
          */
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
</style>